//@ts-nocheck
import { SplitLayout } from "@npd-ng/adp-component-library";
import green_checkmark from "../assets/green_check.svg";
import { Box, Image, Text, Button } from "@enaep-ng/benchmark";
import { Markup } from "interweave";
import { ResultItem, ResultsProps } from "../typings/ViewTypes";
import redAlert from "../assets/red_triangle_exclamation.svg";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IADPState } from "../typings";
import * as img from "../assets"
import { createSetExitAction } from "../state/reducer";


export const DeviceValidationResultsView = () => {
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { rootState: IADPState }) => state.rootState
  );
  const deviceReadinessInfo = useSelector(
    (state: { rootState: IADPState }) =>
      state.rootState.deviceReadinessState.deviceReadinessInfo
  );
  const deviceValidationFailureMsg = useSelector((state:{rootState:IADPState})=>state.rootState.currentLanguageContent?.deviceValidationFailure)

  const resultsSuccessProps: ResultsProps = {
    type: "success",
    title:
      state.currentLanguageContent?.deviceValidationSuccess.title || "",
    subtitle:
      state.currentLanguageContent?.deviceValidationSuccess.subTitle ||
      "",
    warning: {
      title:
        state.currentLanguageContent?.deviceValidationSuccess.notice
          .title || "",
      message:
        state.currentLanguageContent?.deviceValidationSuccess.notice
          .message || "",
      icon: img.plugIcon,
      iconAltText: state.currentLanguageContent?.imageAltText.plugIcon
    },
    button: {
      label: state.currentLanguageContent?.actions.finished || "",
      action: () => {
        dispatch(createSetExitAction());
      },
    },
  };
  const failureresults = [] as ResultItem[];
  if (deviceReadinessInfo) {
    deviceReadinessInfo.failureReason.forEach((reason) => {
      failureresults.push({ message: reason?.messageOnFailure });
    });
  }
  const resultsFailureProps: ResultsProps = {
    type: "error",
    title:
      state.currentLanguageContent?.deviceValidationFailure.title || "",
    subtitle:
      state.currentLanguageContent?.deviceValidationFailure.subTitle ||
      "",
    expandBtn: {
      hideLabel: state.currentLanguageContent?.actions.hideDetails || "",
      showLabel: state.currentLanguageContent?.actions.showDetails || "",
    },
    warning: {
      title:
        state.sessionState.appAccessedFor === "Assess"
          ? state.currentLanguageContent?.deviceValidationFailure.notice
              .assessTitle || ""
          : state.currentLanguageContent?.deviceValidationFailure.notice
              .title || "",
      message:
        state.currentLanguageContent?.deviceValidationFailure.notice
          .message || "",
      icon:
        state.sessionState.appAccessedFor === "Assess"
          ? img.raiseHand
          : img.questionMark,
      iconAltText:
        state.sessionState.appAccessedFor === "Assess"
          ? state.currentLanguageContent?.imageAltText.raiseHandIcon
          : state.currentLanguageContent?.imageAltText.questionMarkIcon,
    },
    results: failureresults,
  };
  if(state.sessionState.appAccessedFor === "Verify"){
    resultsSuccessProps.button =  {
      label: state.currentLanguageContent?.actions.exit || "",
      action: () => {
        dispatch(createSetExitAction());
      },
    }
  }
  const { title, subtitle, warning, results, button, type, expandBtn } = 
  state.appState.currentView === "DeviceValidationSuccessView" ? resultsSuccessProps : resultsFailureProps;
  const [failuresShown, setFailuresShown] = useState(false);
  const renderResults = () => {
    return results?.map((result,index) => {
      return (
        <Box
        key={`box-${index}`}
          style={{
            display: "flex",
          }}
        >
          <Image
            key={`image-${index}`}
            style={{
              width: "calc(22px * var(--zoom))",
              height: "calc(22px * var(--zoom))",
              marginBottom: "calc(18px * var(--zoom))",
              marginRight: "calc(22px * var(--zoom))",
              fontSize:"calc(10px * var(--zoom))"
            }}
            src={redAlert}
            alt={state.currentLanguageContent?.imageAltText.failureTriangleIcon}
          />
          <Text
          key={`text-${index}`}
            style={{
              fontWeight: "bold",
              fontSize: "calc(18px * var(--zoom))",
              color: "#900202",
              margin: "0",
            }}
          >
            {deviceValidationFailureMsg? deviceValidationFailureMsg[result.message]  : ""}
          </Text>
        </Box>
      );
    });
  };
  return (
    <SplitLayout logoAlt={state.currentLanguageContent?.imageAltText.naepLogo as string} alignment="left">
      <Box sx={{ marginLeft: 'calc(22px * var(--zoom))' }}>
        <Box
          style={{
            display: "flex",
          }}
        >
          {type === "success" && (
            <Image
              src={green_checkmark}
              imgHeight={26}
              imgWidth={26}
              style={{
                marginTop: "calc(3px * var(--zoom))",
                fontSize:"calc(10px * var(--zoom))"
              }}
              alt={state.currentLanguageContent?.imageAltText.successIcon}
              
            />
          )}
          {type === "error" && (
            <Image
              id="test"
              src={redAlert}
              imgHeight={26}
              imgWidth={26}
              style={{
                marginRight: "calc(10px * var(--zoom))",
                fontSize:"calc(10px * var(--zoom))"
              }}
              alt={state.currentLanguageContent?.imageAltText.failureTriangleIcon}
            />
          )}
          <Text
            style={{
              fontSize: "calc(30px * var(--zoom))",
              margin: "0",
              color: `${type === "success" ? "#044e98" : "#900202"}`,
              display: "inline-block",
              paddingLeft: `${type === "success" ? "14px" : 0}`,
              paddingBottom: "calc(14px * var(--zoom))",
              lineHeight: "calc(31px * var(--zoom))",
              fontWeight: "600",
            }}
          >
            <Markup content={title} />
          </Text>
        </Box>
        <Box
          sx={{
            paddingBottom: "calc(26px * var(--zoom))",
          }}
        >
          <Text
            style={{
              fontSize: "calc(18px * var(--zoom))",
            }}
          >
            <Markup content={subtitle} />
          </Text>
        </Box>
        {/* Attention Box Start */}
        <Box
          sx={{
            display: "flex",
            position: "relative",
            backgroundColor: "rgba(255, 244, 152, 0.49)",
            borderRadius: "calc(6px * var(--zoom))",
            border: "calc(2px * var(--zoom)) solid #cfba00",
            padding:
              "calc(16px * var(--zoom)) calc(16px * var(--zoom)) calc(16px * var(--zoom)) calc(10px * var(--zoom))",
            maxWidth: "calc(456px * var(--zoom))",
            // marginLeft: 'calc(-13px * var(--zoom))',
            alignItems: "center",
          }}
        >
          {warning.icon && (
            <Image
              src={warning.icon}
              imgHeight={42}
              imgWidth={42}
              style={{
                marginRight: "calc(14px * var(--zoom))",
                fontSize:"calc(10px * var(--zoom))"
              }}
              onerror="this.style.display='none'"
              alt={warning.iconAltText}
            />
          )}
          <Box>
          {warning.title && (
            <Text
              style={{
                fontSize: "calc(18px * var(--zoom))",
                color: "#333333",
                fontWeight: "bold",
                alignSelf: "center",
                flex: 1,
                display: 'table',
              }}
            >
              <Markup content={warning.title}/>
              
            </Text>
          )}
          {warning.message && (
            <Text
              style={{
                flex: 1,
                fontSize: "calc(16px * var(--zoom))",
                alignSelf: "center",
                paddingBottom: "calc(5px * var(--zoom))",
              }}
            >
             <Markup content={warning.message}/>
            </Text>
          )}
          </Box>
        </Box>
        {/* Attention Box End */}
        {expandBtn && (
          <Button
            variant="Bare"
            sx={{
              border: "none",
              backgroundColor: "transparent",
              padding: 0,
              color: "#900202",
              textDecoration: "underline",
              fontWeight: 600,
              marginTop: "calc(20px  * var(--zoom))",
              fontSize: "calc(18px * var(--zoom))",
            }}
            onClick={() => setFailuresShown(!failuresShown)}
          >
            {failuresShown ? expandBtn.hideLabel : expandBtn.showLabel}
          </Button>
        )}
        <Box
          style={{
            marginTop: "calc(22px * var(--zoom))",
          }}
        >
          {failuresShown && renderResults()}
        </Box>
        {button && (
          <Button
            style={{
              backgroundColor: "#0a1971",
              borderRadius: "calc(8px * var(--zoom))",
              color: "#ffffff",
              cursor: "pointer",
              display: "block",
              fontSize: "calc(20px * var(--zoom))",
              height: "calc(57px * var(--zoom))",
              marginTop: "calc(64.4px * var(--zoom))",
              width: "calc(197px * var(--zoom))",
            }}
            onClick={button.action}
          >
            <Markup content={button.label} />
          </Button>
        )}
      </Box>
    </SplitLayout>
  );
};
